@if (uiState == uiStateEnumForTemplate.ShowLoading) {
  <div class="center-margin">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <c-container class="mt-5 mb-5">
    <h2>Add New Role</h2>

    <button mat-raised-button
            class="margin-bottom-med margin-top-med"
            data-testid="back-to-manage-roles-button"
            routerLink="/manage-global-permissions">
      <mat-icon>arrow_back_ios</mat-icon>
      Back to Roles
    </button>

    <mat-stepper orientation="vertical" linear>

      <!-- Role Details -->
      <mat-step [stepControl]="createRoleForm">
        <form [formGroup]="createRoleForm">
          <ng-template matStepLabel>Role Details</ng-template>
          <div class="mt-3">
            <mat-form-field appearance="outline" class="small-input">
              <mat-label>Enter New Role Name</mat-label>
              <input formControlName="roleName" type="text" matInput data-testid="new-role-name-input"
                     placeholder="Enter role name">
              @if (roleNameControl.hasError('required')) {
                <mat-error data-testid="role-name-error">
                  Name is required
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="small-input">
              <mat-label>Enter New Role Description</mat-label>
              <textarea formControlName="roleDescription" matInput data-testid="new-role-description-input"
                        placeholder="Enter role description"></textarea>
              @if (roleDescriptionControl.hasError('required')) {
                <mat-error data-testid="role-description-error">
                  Role description is required
                </mat-error>
              }
            </mat-form-field>

            <mat-checkbox formControlName="isCrossGameRole" data-testid="role-is-cross-game-checkbox">Is Cross Game Role</mat-checkbox>

            <div class="stepper-buttons mt-3">
              <button mat-raised-button color="primary" matStepperNext data-testid="role-details-next-button">Next</button>
            </div>
          </div>
        </form>
      </mat-step>

      <!-- Select Permissions -->
      <mat-step>
        <ng-template matStepLabel>Select Permissions</ng-template>

        <app-permissions-selector
            [availablePermissions]="availablePermissions"
            [(selectedPermissions)]="selectedPermissions"> 
        </app-permissions-selector>

        <div class="stepper-buttons mt-3">
          <button mat-button matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" matStepperNext data-testid="select-permissions-next-button">Next</button>
        </div>
      </mat-step>

      <!-- Summary -->
      <mat-step>
        <ng-template matStepLabel>Summary</ng-template>

        <div class="my-4">
          <div class="mat-body-1 mb-3">
            <p><strong>Name:</strong> <span data-testid="summary-role-name">{{ createRoleForm.value.roleName }}</span></p>
            <p><strong>Description:</strong> <span data-testid="summary-role-description">{{ createRoleForm.value.roleDescription }}</span></p>
            <p><strong>Cross Game:</strong> <span data-testid="summary-cross-game">{{ createRoleForm.value.isCrossGameRole ? 'Yes' : 'No' }}</span></p>
          </div>

          <div class="mat-body-1">
            <div class="mb-2"><strong>Permissions ({{ selectedPermissions.length }}):</strong></div>
            <div class="flex flex-wrap gap-2">
              @if (selectedPermissions.length === 0) {
                <mat-error>No permissions selected</mat-error>
              }
              @for (permission of selectedPermissions; track permission) {
                <mat-chip [attr.data-testid]="'summary-permission-' + permission.Value">{{ permission.Name }}</mat-chip>
              }
            </div>
          </div>
        </div>

        <div class="stepper-buttons mt-3">
          <button mat-button matStepperPrevious>Back</button>
          <button mat-raised-button color="primary"
                  (click)="createRole()"
                  data-testid="create-role-button">
            Create Role
          </button>
        </div>
      </mat-step>
    </mat-stepper>

  </c-container>
}